<template>
  <div class="ai-suggestion-box">
    <div class="card">
      <div class="card-header">
        <h4>AI Response Suggestion</h4>
      </div>
      <div class="card-body">
        <div v-if="loading" class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-else>
          <div class="form-group">
            <label>Survey Response:</label>
            <p class="survey-response">{{ surveyResponse }}</p>
          </div>
          <div class="form-group">
            <label>Crystals in this batch:</label>
            <div class="crystal-tags">
              <span v-for="crystal in crystals" :key="crystal.id" class="badge badge-primary mr-2">
                {{ crystal.title }}
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Additional Context (Optional):</label>
            <textarea 
              v-model="additionalContext" 
              class="form-control" 
              rows="3"
              placeholder="Add any additional context or specific points you'd like the AI to consider..."
            ></textarea>
          </div>
          <div class="form-group">
            <label>Response Length:</label>
            <div class="btn-group" role="group">
              <button 
                type="button" 
                class="btn" 
                :class="responseLength === 'short' ? 'btn-primary' : 'btn-outline-primary'"
                @click="responseLength = 'short'"
              >
                Short
              </button>
              <button 
                type="button" 
                class="btn" 
                :class="responseLength === 'long' ? 'btn-primary' : 'btn-outline-primary'"
                @click="responseLength = 'long'"
              >
                Long
              </button>
            </div>
          </div>
          <div class="form-group">
            <label>AI Suggestion:</label>
            <textarea 
              v-model="aiSuggestion" 
              class="form-control" 
              rows="4"
              :disabled="loading"
            ></textarea>
          </div>
          <div class="form-group">
            <button 
              @click="generateSuggestion" 
              class="btn btn-primary"
              :disabled="loading"
            >
              Generate Suggestion
            </button>
            <button 
              @click="applySuggestion" 
              class="btn btn-success ml-2"
              :disabled="!aiSuggestion || loading"
            >
              Apply Suggestion
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subscriptionBoxId: {
      type: Number,
      required: true
    },
    surveyResponse: {
      type: String,
      required: true
    },
    crystals: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      aiSuggestion: '',
      error: null,
      additionalContext: '',
      responseLength: 'short'
    }
  },
  methods: {
    async generateSuggestion() {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await this.$http.post('/admin/ai-suggest-response', {
          subscription_box_id: this.subscriptionBoxId,
          survey_response: this.surveyResponse,
          crystals: this.crystals,
          additional_context: this.additionalContext,
          response_length: this.responseLength
        }, {
          headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            'Accept': 'application/json'
          }
        });
        
        this.aiSuggestion = response.data.suggestion;
      } catch (error) {
        this.error = error.response?.data?.message || 'Failed to generate suggestion';
        console.error('Error generating suggestion:', error);
      } finally {
        this.loading = false;
      }
    },
    async applySuggestion() {
      if (!this.aiSuggestion) return;
      
      this.loading = true;
      this.error = null;
      
      try {
        await this.$http.post('/admin/update-response', {
          subscription_box_id: this.subscriptionBoxId,
          custom_admin_response: this.aiSuggestion
        }, {
          headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            'Accept': 'application/json'
          }
        });
        
        this.$emit('response-updated', this.aiSuggestion);
        this.aiSuggestion = '';
      } catch (error) {
        this.error = error.response?.data?.message || 'Failed to apply suggestion';
        console.error('Error applying suggestion:', error);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.ai-suggestion-box {
  margin-bottom: 20px;
}

.survey-response {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.crystal-tags {
  margin-bottom: 15px;
}

.badge {
  font-size: 0.9em;
  padding: 5px 10px;
}

.btn-group {
  margin-bottom: 15px;
}
</style> 